import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "profile-creation-wizard__side" }
const _hoisted_2 = { class: "profile-creation-wizard__side-mobile" }
const _hoisted_3 = { slot: "bottom-sheet-content" }
const _hoisted_4 = { slot: "bottom-sheet-content" }
const _hoisted_5 = { slot: "bottom-sheet-content" }
const _hoisted_6 = { class: "profile-creation-wizard__side-desktop" }
const _hoisted_7 = { class: "profile-creation-wizard__side-description" }
const _hoisted_8 = { class: "profile-creation-wizard__side-iconTitle" }
const _hoisted_9 = { class: "profile-creation-wizard__side-description" }
const _hoisted_10 = { class: "profile-creation-wizard__side-iconTitle" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_joy_bottom_sheet = _resolveComponent("joy-bottom-sheet")!
  const _component_joy_icon = _resolveComponent("joy-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_joy_bottom_sheet, {
        id: "details-experience-bottom-sheet",
        "close-label": _ctx.$msg('general.close')
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.$msg('profile.creation.completion.wizard.details.experience.help')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$msg('profile.creation.completion.wizard.side.details.experience.subtitle')), 1)
          ])
        ]),
        _: 1
      }, 8, ["close-label"]),
      _createVNode(_component_joy_bottom_sheet, {
        id: "details-skills-bottom-sheet",
        "close-label": _ctx.$msg('general.close')
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.$msg('profile.creation.completion.wizard.details.skills.help')), 1),
            _createElementVNode("strong", null, _toDisplayString(_ctx.$msg('profile.creation.completion.wizard.v2.side.details.skills.title')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$msg('profile.creation.completion.wizard.v2.side.details.skills.subtitle')), 1)
          ])
        ]),
        _: 1
      }, 8, ["close-label"]),
      _createVNode(_component_joy_bottom_sheet, {
        id: "details-price-bottom-sheet",
        "close-label": _ctx.$msg('general.close')
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.$msg('profile.creation.completion.wizard.details.price.help')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$msg('profile.creation.completion.wizard.v2.side.details.price.subtitle.one')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$msg('profile.creation.completion.wizard.v2.side.details.price.subtitle.two')), 1)
          ])
        ]),
        _: 1
      }, 8, ["close-label"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", {
        class: _normalizeClass(["profile-creation-wizard__side-container", {'no-focus': !_ctx.isTagsFocus, 'focus-tags': _ctx.isTagsFocus}]),
        style: _normalizeStyle(_ctx.tipsClassPosition)
      }, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_joy_icon, {
              name: "chess",
              size: "small"
            }),
            _createElementVNode("strong", null, _toDisplayString(_ctx.$msg('profile.creation.completion.wizard.v2.side.details.skills.title')), 1)
          ]),
          _createElementVNode("p", null, _toDisplayString(_ctx.$msg('profile.creation.completion.wizard.v2.side.details.skills.subtitle')), 1)
        ])
      ], 6),
      _createElementVNode("div", {
        class: _normalizeClass(["profile-creation-wizard__side-container", {'no-focus': !_ctx.isPriceFocus, 'focus-price': _ctx.isPriceFocus}]),
        style: _normalizeStyle(_ctx.tipsClassPosition)
      }, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_joy_icon, {
              name: "money",
              size: "small"
            }),
            _createElementVNode("strong", null, _toDisplayString(_ctx.$msg('profile.creation.completion.wizard.side.details.price.title')), 1)
          ]),
          _createElementVNode("p", null, [
            _createTextVNode(_toDisplayString(_ctx.$msg('profile.creation.completion.wizard.v2.side.details.price.subtitle.one')) + " ", 1),
            _hoisted_11,
            _createTextVNode(" " + _toDisplayString(_ctx.$msg('profile.creation.completion.wizard.v2.side.details.price.subtitle.two')), 1)
          ])
        ])
      ], 6)
    ])
  ]))
}